import React, { useState } from 'react'
import './UsecaseCreate.scss'

import { Stepper, Step, StepButton, StepLabel, CircularProgress, Typography, Grid } from '@material-ui/core'
import { Formik, Form } from 'formik'

import CreateGeneralForm from './Forms/CreateGeneralForm/CreateGeneralForm'
import CreateSituationForm from './Forms/CreateSituationForm/CreateSituationForm'
import CreateAssetsForm from './Forms/CreateAssetsForm/CreateAssetsForm'
import CreateThreatsForm from './Forms/CreateThreatForm/CreateThreatsForm'
import CreateSuccess from './Forms/CreateSuccess/CreateSuccess'

import validationSchema from './FormsModel/validationSchema'
import createUsecaseFormModel from './FormsModel/createUsecaseFormModel'
import createUsecaseFormInitialValues from './FormsModel/createUsecaseFormInitialValues'
import createUsecasePrefilledFormData from './FormsModel/createUsecasePrefilledFormData'

import BreadcrumBar from '../MainLayout/BreadcrumbBar/BreadcrumBar'
import { postUsecase, getEnvironmentConfig } from '../../services/usecase.service'
import { EnvironmentData, Usecase } from 'src/redux/reducers/types'

const steps = [
    { title: 'Use case', subtitle: 'General' },
    { title: 'Situation', subtitle: 'Define the situation' },
    { title: 'Assets', subtitle: 'Define the players' },
    { title: 'Threat', subtitle: 'Define the threat' },
]
const { formId, formField } = createUsecaseFormModel

function _renderStepContent(step: number, environmentData: any) {
    let environments = environmentData

    switch (step) {
        case 0:
            return <CreateGeneralForm formField={formField} />
        case 1:
            return <CreateSituationForm formField={formField} />
        case 2:
            return <CreateAssetsForm environmentData={environments} formField={formField} />
        case 3:
            return <CreateThreatsForm environmentData={environments} formField={formField} />
        default:
            return <div>Not Found</div>
    }
}

function UsecaseCreate() {
    const [activeStep, setActiveStep] = useState(0)
    const [requestMessage, setRequestMessage] = useState('')
    const [environmentData, setEnvironmentData] = useState<EnvironmentData[]>([])
    const [environmentConfigurationId, setEnvironmentConfigurationId] = useState<number | null>(null)
    const currentValidationSchema = validationSchema[activeStep]
    const isLastStep = activeStep === steps.length - 1
    const [initialValues, setInitialValues] = useState<any>(createUsecaseFormInitialValues)

    async function _submitForm(values: Usecase, actions: any) {
        try {
            actions.setSubmitting(false)
            const post_result = await postUsecase(values)

            if (Array.isArray(post_result)) {
                if (!post_result[0].success && !post_result[0].uploaded) {
                    alert('Error: ' + post_result[0].message)
                } else {
                    setRequestMessage(post_result[0].message)
                    setActiveStep(activeStep + 1)
                }
            } else {
                alert('Error on response type')
            }
        } catch (e) {
            alert('Error on response: ' + e)
        }
    }

    function _handleSubmit(values: Usecase, actions: any) {
        if (isLastStep) {
            _submitForm(values, actions)
        } else {
            setActiveStep(activeStep + 1)
            actions.setTouched({})
            actions.setSubmitting(false)
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1)
    }

    async function getEnvironmentConfigFromDB(id: number) {
        const result = await getEnvironmentConfig(id)
        let processedData: EnvironmentData[] = []

        function createDataForEnvironmentSelects(nameOnSelect: string, realValue: string) {
            return {
                value: realValue,
                label: nameOnSelect,
            }
        }

        result.data.environment_config.data.map((item: any) => {
            processedData.push(createDataForEnvironmentSelects(item.name, item.name))
        })

        if (processedData.length < 0) {
            processedData.push(createDataForEnvironmentSelects('Default', 'default'))
        }

        setEnvironmentConfigurationId(id) // SET TO NO REFETCH FROM DB UNLESS DATA ACTUALLY CHANGED
        setEnvironmentData(processedData) // SET THE DATA FOR THE SELECT ELEMENTS
    }

    function _handleEnvirionmentConfigurationFetch(activeStep: number, formData: any) {
        if (environmentConfigurationId === null || environmentConfigurationId !== formData['environment_config_id']) {
            if (activeStep === 1) {
                const config_id = formData['environment_config_id']
                getEnvironmentConfigFromDB(config_id)
            }
        }
    }

    return (
        <>
            <div className="BreadcrumbBar">
                <BreadcrumBar />
            </div>

            <Grid className="GridContainer" container spacing={1}>
                <Grid item xs={1} sm={3}>
                    <span></span>
                </Grid>
                <Grid item xs={10} sm={6}>
                    <div className="UsecaseCreate" data-test-id="usecase-create">
                        <React.Fragment>
                            <Stepper activeStep={activeStep} data-test-id="usecase-create-stepper">
                                {steps.map((label) => (
                                    <Step key={label.title}>
                                        {activeStep !== 0 ? (
                                            <StepButton color="inherit" onClick={_handleBack}>
                                                <StepLabel>
                                                    <div className="ToLeft">
                                                        <Typography variant="subtitle2">{label.title}</Typography>
                                                        <Typography variant="caption">{label.subtitle}</Typography>
                                                    </div>
                                                </StepLabel>
                                            </StepButton>
                                        ) : (
                                            <StepButton color="inherit">
                                                <StepLabel>
                                                    <div className="ToLeft">
                                                        <Typography variant="subtitle2">{label.title}</Typography>
                                                        <Typography variant="caption">{label.subtitle}</Typography>
                                                    </div>
                                                </StepLabel>
                                            </StepButton>
                                        )}
                                    </Step>
                                ))}
                            </Stepper>
                            <React.Fragment>
                                {activeStep === steps.length ? (
                                    <CreateSuccess msg={requestMessage} />
                                ) : (
                                    <Formik
                                        enableReinitialize={true}
                                        initialValues={initialValues}
                                        validationSchema={currentValidationSchema}
                                        onSubmit={_handleSubmit}
                                    >
                                        {({ isSubmitting, values }) => (
                                            <Form id={formId}>
                                                {_handleEnvirionmentConfigurationFetch(activeStep, values)}
                                                {_renderStepContent(activeStep, environmentData)}
                                                {activeStep == 0 && (
                                                    <div
                                                        className="MagicButton"
                                                        onClick={(_e: React.MouseEvent<any>) => {
                                                            console.log('SET CASTOR MAGIC!')
                                                            setInitialValues(createUsecasePrefilledFormData)
                                                        }}
                                                    >
                                                        🦫🪄
                                                    </div>
                                                )}
                                                <div className="FormControlButton">
                                                    {activeStep !== 0 && (
                                                        <button
                                                            type="button"
                                                            className="btn outline primary"
                                                            onClick={_handleBack}
                                                            data-test-id="usecase-create_btn_previous"
                                                        >
                                                            Previous
                                                        </button>
                                                    )}
                                                    <span> </span>
                                                    <button
                                                        className="btn filled primary ButtonSpace"
                                                        data-test-id="usecase-create_btn_next"
                                                    >
                                                        {isLastStep ? 'Confirm' : 'Next'}
                                                    </button>
                                                    {isSubmitting && (
                                                        <div className="SpinnerContainer" data-test-id="usecase-create-spinner">
                                                            <CircularProgress size={64} />
                                                        </div>
                                                    )}
                                                </div>
                                                <br />
                                                <br />
                                                <br />
                                            </Form>
                                        )}
                                    </Formik>
                                )}
                            </React.Fragment>
                        </React.Fragment>
                    </div>
                </Grid>
                <Grid item xs={1} sm={3}>
                    <span></span>
                </Grid>
            </Grid>
        </>
    )
}

export default UsecaseCreate
